import React from 'react';
import { Navigate } from 'react-router-dom';
import { isClientUser } from 'models/user-management/helpers/client-check';
import { isDriverUser } from 'models/user-management/helpers/driver-check';
import { isMobileViewport } from 'models/shared/helpers/postLoginRedirect';

function RequireAssetsAccess({ children }: { children: JSX.Element }) {
	if (isDriverUser()) {
		return <Navigate to="/map" replace />;
	}

	if (isMobileViewport() && isClientUser()) {
		return <Navigate to="/map" replace />;
	}

	return children;
}

export default RequireAssetsAccess;
